import z from "zod";

export const transactionSchema = z.object({
  category: z.enum(["upperBody", "lowerBody", "cardio"]),
  date: z.string().min(1, { message: "日付は必須です" }),
  workout: z
    .union([
      z.enum([
        "サイドレイズ",
        "アームカール",
        "ベンチプレス",
        "チンニング",
        "ベントオーバーロウ",
        "フロントプレス",
      ]),
      z.enum(["スクワット", "デッドリフト"]),
      z.enum(["ランニング", "スイミング"]),
      z.literal(""),
    ])
    .refine((val) => val !== "", { message: "カテゴリを選択してください" }),
  detail: z
    .string()
    .min(0)
    .max(50, { message: "内容は50文字以内にしてください" }),
  workoutSet: z.array(
    z.object({
      set_no: z.number().min(1, { message: "セットは必須です" }),
      weight: z.number().min(0, { message: "重量は必須です" }),
      rep: z.number().min(1, { message: "レップは必須です" }),
    }),
  ),
});
